module.exports = __webpack_public_path__ + "img/icon-clock.774239fb.svg";